// Shortcut to Riwayat Pembaruan with the unread badge (Issue 13). Replaces both the old header button
// (src/features/patch-logs/PatchLogHistoryButton.tsx, deleted in PR 10a) and the rail footer row; same query, same page.
import { HistoryIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { pageUrl } from '@constants/url';
import { useUnreadPatchLogCount } from '@hooks/patch-logs/use-patch-logs';
import { useHaptic } from '@utils/haptic';
import { resolvePatchLogCopy } from '@/features/patch-logs';
import { isPatchLogLocale, type PatchLogLocale } from '@/features/patch-logs/types';
import { useLanguage } from '@/contexts/LanguageContext';
import { capCount } from './notification-format';
import { TopbarIconButton } from './TopbarIconButton';

export function PatchLogButton() {
  const { language } = useLanguage();
  const navigate = useNavigate();
  const hapticMedium = useHaptic('medium');
  // Shares the gate's query, so the badge and the blocking modal never disagree about what is unread.
  const unread = useUnreadPatchLogCount();

  const locale: PatchLogLocale = isPatchLogLocale(language) ? language : 'id';
  const label = resolvePatchLogCopy(locale, 'history');

  return (
    <span className="relative inline-flex">
      <TopbarIconButton
        label={label}
        aria-label={unread > 0 ? `${label} (${unread})` : label}
        onClick={() => {
          hapticMedium();
          navigate(pageUrl.riwayatPembaruan);
        }}
      >
        <HistoryIcon />
      </TopbarIconButton>
      {unread > 0 && (
        <span
          aria-hidden
          className="pointer-events-none absolute -top-0.5 -right-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-err px-1 font-bold text-[10px] text-on-err leading-none ring-2 ring-canvas"
        >
          {capCount(unread, 9)}
        </span>
      )}
    </span>
  );
}
